export default __webpack_public_path__ + "9a71796745a3ec99dc4c12a0ca065504.otf";